import { sanitizeOptions } from '../../../core/directives/input-rich-text/utils/sanitize'

/* @ngInject */
function InternalApprovalCardController ($scope, $sce, $rootScope, $q, $translate, $timeout, $element, AssetPreviewService, ApprovalsService, Utils, UserService, TasksService, ToastService, UdsModalService, ConfirmationModalService, SegmentService) {
  const getSanitizeHtmlModule = () => import('sanitize-html')

  const getApprovalFormDialogController = () => $q.when(import('../../dialogs/approval-form/approval-form-dialog.controller'))
  const getRequestReviewApproval = () => $q.when(import('../../dialogs/request-review-approval/request-review-approval-dialog.controller'))

  $scope.flags = {
    showDetails: false,
    showReviewActions: !!$rootScope.isGuest(),
    loadingAssets: false,
    loadingDeleteApproval: false
  }
  $scope.assets = []

  $scope.approvalMessage = ''

  const api = {
    getSanitizeHtmlModule,
    getApprovalFormDialogController,
    getRequestReviewApproval,
    _loadAssets,
    _getPreviewAssets,
    _getAvailableAssetsToApproval,
    _updateApprovalAssets,
    _setMessageValue
  }
  this.getApi = () => api

  activate()

  function activate () {
    const message = $scope.approval.message

    if (message) {
      api._setMessageValue(message)
    }
  }

  const deregisterInternalApprovalCard = $rootScope.$on('internal-approval-card.reload', () => {
    api._updateApprovalAssets()
  })

  const deregisterApprovalWatcher = $scope.$watchCollection('approval', api._updateApprovalAssets)

  $scope.$on('$destroy', () => {
    deregisterInternalApprovalCard()
    deregisterApprovalWatcher()
  })

  $scope.handleReviewAssets = () => {
    const assets = api._getAvailableAssetsToApproval()

    AssetPreviewService.openAssetPreview({
      location: 'workflow',
      internalApproval: $scope.approval,
      task: $scope.task,
      asset: assets[0],
      getPreviewAssets: () => api._getPreviewAssets(assets)
    })
  }

  $scope.handleEditApproval = (approvalId) => {
    api.getApprovalFormDialogController().then(({ ApprovalFormDialogController }) => {
      const dialog = UdsModalService.createModal({
        controller: ApprovalFormDialogController,
        modalName: 'approvalFormDialog',
        data: {
          approvalId: $scope.approval.id,
          approverIds: $scope.approval.approverIds,
          approvers: $scope.approval.approvers,
          message: $scope.approval.message,
          deadline: $scope.approval.deadline,
          taskId: $scope.approval.taskId,
          approvalAssets: $scope.approval.approvalAssets
        },
        onClose: (wasUpdated) => {
          if (wasUpdated) {
            ToastService.showSuccessToast($translate.instant('internalApprovalCard.editApprovalSuccess'))
            if ($scope.onUpdate) {
              $scope.onUpdate()
            }
          }
        }
      })
      dialog.open()
    })
  }

  $scope.handleDeleteApproval = (approvalId) => {
    ConfirmationModalService.createModal({
      title: $translate.instant('warning'),
      description: $translate.instant('internalApprovalCard.deleteApprovalConfirmation'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('delete'),
      onConfirm: () => {
        $scope.flags.loadingDeleteApproval = true
        ApprovalsService.deleteApproval(approvalId).then(() => {
          $scope.flags.loadingDeleteApproval = false
          ToastService.showSuccessToast($translate.instant('internalApprovalCard.deleteApprovalSuccess'))
          $rootScope.$emit('workflow.reload-active-internal-approval')
          $rootScope.$broadcast('workflow.saved-column')

          if ($scope.onDelete) {
            $scope.onDelete()
          }

          SegmentService.track('workflow-internal-approval-remove', {
            task_id: $scope.approval.taskId,
            internal_approval_id: approvalId
          })
        }).catch(() => {
          $scope.flags.loadingDeleteApproval = false
          ToastService.defaultErrorToast()
        })
      }
    })
  }

  $scope.handleReviewApproval = (statusFrom, statusTo) => {
    api.getRequestReviewApproval().then(({ RequestReviewApprovalController }) => {
      const dialog = UdsModalService.createModal({
        controller: RequestReviewApprovalController,
        modalName: 'requestReviewApprovalDialog',
        data: {
          taskId: $scope.approval.taskId,
          approvalId: $scope.approval.id,
          from: statusFrom,
          to: statusTo
        },
        onClose: (success) => {
          if (success) {
            if ($scope.onApproval) {
              $scope.onApproval()
            }
          }
        }
      })
      dialog.open()
    })
  }

  $scope.handleReviewRequest = () => {
    $scope.flags.showReviewActions = !$scope.flags.showReviewActions
  }

  $scope.handleOpenDetails = () => {
    $scope.flags.showDetails = !$scope.flags.showDetails

    if ($scope.approval.approvalAssets.length > 0 && $scope.assets.length === 0) {
      api._loadAssets()
    }
  }

  $scope.getApproverAvatar = (approverId) => {
    return UserService.getUserProfileImage(approverId)
  }

  $scope.getApproverCountTooltipContent = (approvers) => {
    if (!approvers?.length || !Array.isArray(approvers)) return ''

    const approversToShowInTooltip = approvers.slice(3)
    return approversToShowInTooltip.reduce((acc, approver) => {
      acc = acc + `${approver.name}<br>`
      return acc
    }, '')
  }

  $scope.getTooltipContentWithApproverStatus = (approver) => {
    return ApprovalsService.getApproverTooltipContentWithStatus(approver)
  }

  $scope.getCorrespondingInternalApprovalAsset = (asset) => {
    return $scope.approval.approvalAssets.find(approvalAsset => approvalAsset.assetId === asset.assetId)
  }

  $scope.getDeadline = (deadline, locale) => {
    const date = Utils.formatDate(deadline, locale)
    const time = Utils.formatDate(deadline, locale, {
      hour: 'numeric',
      minute: 'numeric'
    })

    return `${date}, ${time}`
  }

  $scope.showCloseIcon = (show) => {
    return show ? 'close' : ''
  }

  $scope.showReviewAssetButton = () => {
    const approverRecords = $scope.approval.approvalAssets.map(asset => {
      return asset.approvers.find(approver => approver.id === $rootScope.oUser.id)
    })
    const isApprover = approverRecords.some(record => !!record)
    const isPendingStatus = approverRecords.some(approverRecord => approverRecord?.approvalStatus === 'PENDING')

    return isApprover && isPendingStatus && $scope.approval.approvalAssets.length > 0 && !$scope.noInteraction
  }

  $scope.showReviewRequestButton = () => {
    const approverRecord = $scope.approval.approvers.find(approver => approver.id === $rootScope.oUser.id)
    const isApprover = !!approverRecord
    const isPendingStatus = approverRecord?.approvalStatus === 'PENDING'

    return isApprover && isPendingStatus && $scope.approval.approvalAssets.length === 0 && !$scope.noInteraction
  }

  $scope.showApprovalButtons = () => {
    const approverRecord = $scope.approval.approvers.find(approver => approver.id === $rootScope.oUser.id)
    const isApprover = !!approverRecord
    const isPendingStatus = approverRecord?.approvalStatus === 'PENDING'

    return isApprover && isPendingStatus && $scope.approval.approvalAssets.length === 0 && $scope.flags.showReviewActions && !$scope.noInteraction
  }

  $scope.showApprovalConfigButtons = () => {
    const isAdmin = $rootScope.isUserSysAdminAdmin()
    const isCreator = $scope.approval.createdBy === $rootScope.oUser.id
    const isApprover = $scope.approval.approverIds.includes($rootScope.oUser.id)
    const isPendingStatus = $scope.approval.status === 'PENDING'

    return ((isAdmin && !isApprover) || (isCreator && isPendingStatus)) && !$scope.noInteraction
  }

  function _loadAssets () {
    $scope.flags.loadingAssets = true
    const assetsIds = $scope.approval.approvalAssets.map(asset => asset.assetId)
    return TasksService.getAttachments($scope.approval.taskId, false, 'private', assetsIds).then(assets => {
      $scope.flags.loadingAssets = false
      $scope.assets = assets
    }).catch(() => {
      $scope.flags.loadingAssets = false
      ToastService.defaultErrorToast()
    })
  }

  function _getPreviewAssets (assets) {
    const deferred = $q.defer()

    deferred.resolve({
      assets,
      count: assets.length
    })

    return deferred.promise
  }

  function _getAvailableAssetsToApproval () {
    const approvalAssets = $scope.approval.approvalAssets
    const assets = $scope.assets

    const availableAssets = assets.filter(asset => {
      const isAvailableAsset = approvalAssets.find(approvalAsset => {
        if (approvalAsset.assetId !== asset.id) return false

        const userApprover = approvalAsset.approvers.find(approver => approver.id === $rootScope.oUser.id)
        return userApprover?.approvalStatus === 'PENDING'
      })
      return isAvailableAsset?.assetId === asset.id
    })

    return availableAssets
  }

  function _updateApprovalAssets () {
    const hasApprovalAssets = $scope.approval?.approvalAssets?.length
    const isPendingApproval = $scope.approval?.status === 'PENDING'

    if (hasApprovalAssets && isPendingApproval) {
      api._loadAssets()
    }
  }

  function _setMessageValue (message) {
    if (message) {
      api.getSanitizeHtmlModule().then((SanitizeHtmlModule) => {
        const sanitizeHtml = SanitizeHtmlModule.default
        const messageElement = $element.find('[data-message]')[0]

        messageElement.innerHTML = sanitizeHtml(message, sanitizeOptions)
        messageElement.innerHTML = Utils.removeNBSPSymbol(messageElement.innerHTML)
      })
    }
  }
}

export { InternalApprovalCardController }
